const IOLPAY_WRAPPER_ID = 'iol-pay-container';
const IOLPAY_WRAPPER_CLASS = 'iol-pay-container-wrapper';
const IFRAME_ID = 'iol-pay-iframe-element';
export class IOLPay {
	constructor(
		onloadFunc = function () {
			return;
		}
	) {
		this.debugMode = false;
		this.onloadFunc = onloadFunc;
		this.domainAllowed = true;
		this._submitLoading = false;
		this._submitLoaded = false;
	}
	get submitLoading() {
		return this._submitLoading;
	}

	get submitLoaded() {
		return this._submitLoaded;
	}

	init(paymentSettings) {
		this.paymentSettings = paymentSettings;
		this.initializeIframe(paymentSettings?.ecomUrl);
		this.mountIframe();
	}
	submitPayment() {
		this._submitLoading = true;
		this._submitLoaded = false;
		const obj = {
			type: 'SUBMIT_PAYMENT',
			value: {
				submitLoading: this._submitLoading,
				submitLoaded: this._submitLoaded,
			},
		};

		this.iframe.contentWindow.postMessage(obj, '*');
	}
	initializeIframe(url) {
		if (!document.getElementById(IFRAME_ID)) {
			const iframe = document.createElement('iframe');
			const obj = {
				type: 'INIT_IFRAME',
				value: {
					paymentSettings: this.paymentSettings,
					topHost: window.location.host,
				},
			};
			iframe.onload = () => {
				this.iframe.contentWindow.postMessage(obj, '*');
			};
			//iframe.src = 'https://sandbox.iolpay.com/';
			iframe.src = url;
			iframe.id = IFRAME_ID;
			iframe.allowpaymentrequest = true;
			iframe.allow = 'payment';
			iframe.crossorigin = 'anonymous';
			iframe.style = 'width: 100%; height: 100%;';
			this.iframe = iframe;
		} else {
			console.log('iol-pay-iframe-element MISSING');
			const obj = {
				type: 'INIT_IFRAME',
				value: {
					paymentSettings: this.paymentSettings,
					topHost: window.location.host,
				},
			};
			this.iframe.contentWindow.postMessage(obj, '*');
		}
	}
	receiveMessage(event) {
		console.log(event.data);
	}
	mountIframe() {
		if (!document.getElementById(IFRAME_ID)) {
			window.addEventListener('message', this.receiveMessage, false);
			const wrapper = document.createElement('div');
			wrapper.id = IOLPAY_WRAPPER_ID;
			wrapper.className = IOLPAY_WRAPPER_CLASS;
			wrapper.style = `height: 500px;`;
			wrapper.appendChild(this.iframe);
			console.log('iframe ', this.iframe);
			let modalPay = document.getElementsByClassName('modalPay');
			console.log('modalPay ', modalPay);
			console.log('modalPay.length ', modalPay.length);
			document.getElementsByClassName('modalPay')[0]?.appendChild(wrapper);
			/*  $('divCheckOutPanel').empty();*/
			//$(wrapper).insertAfter($('.checkout')); // -> replace this $CLASS__NAME$ with the class name or id of your div where you want to show the checkout panel.
			/*  $('#section-pay-now-btn').show();*/
			// $('#modal').show();
		}
	}
	unmountIframe() {
		console.log('Unmount iframe called');
		// Unmount iframe logic here
		// For example:
		const iframe = document.getElementById('iolpay-iframe');
		if (iframe) {
			iframe.remove();
			console.log('Iframe removed');
		} else {
			console.log('Iframe not found');
		}
	}
}
// export default ((window) => {
// 	const iolpaySdk = window.iolpay;
// 	const initCall = iolpaySdk._c.filter((call) => call[0] === 'init');
// 	const shim = new IOLPay();
// 	iolpaySdk.init = shim.init.bind(shim);
// 	iolpaySdk.submitPayment = shim.submitPayment.bind(shim);
// 	initCall && shim.init(initCall[0][1][0]);
// })(window);
